import { ExclamationMarkTriangle } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

import { ScanResourcesListItem } from "../../../types";

const ScanResourcesTableStatusCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<ScanResourcesListItem>) => {
  const isManaged = resource.isManaged;
  const textContent = isManaged ? "Managed" : "Unmanaged";

  return (
    <TableSimpleCell {...cellProps}>
      <Box align="center" gap="small">
        {isManaged ? null : <Icon src={ExclamationMarkTriangle} color="warning" noShrink />}
        <TextEllipsis tooltip={textContent}>
          {(props) => (
            <Typography
              {...props}
              tag="span"
              variant="p-body3"
              color={isManaged ? undefined : "warning"}
            >
              {textContent}
            </Typography>
          )}
        </TextEllipsis>
      </Box>
    </TableSimpleCell>
  );
};

export default ScanResourcesTableStatusCell;
